import type {
  HomeCategoryCircle,
  HomeContentCard,
  HomeFeatureCard,
  HomeLifestyleCard,
  HomePromoBanner,
  HomeServiceIcon,
} from "@/types/catalog";
import { categoryPath, searchPath } from "@/lib/routes";

function img(seed: string) {
  return `https://picsum.photos/seed/${seed}/600/400`;
}

export const homeHero = {
  eyebrow: "New season",
  title: "Winter inspiration starts here",
  description:
    "Cosy layers, warm textures and simple updates to refresh your space for the cooler months.",
  ctaLabel: "Shop the collection",
  ctaHref: categoryPath("home-living"),
  image: img("winter-hero"),
};

export const homeAppBanner = {
  message: "Download the free Kmart app for exclusive offers and faster checkout.",
  linkText: "Get the app",
};

export const circularCategories: HomeCategoryCircle[] = [
  { id: "kitchen", label: "Kitchen & Dining", image: img("kitchen"), href: categoryPath("home-living") },
  { id: "decor", label: "Home Decor", image: img("decor"), href: categoryPath("home-living") },
  { id: "bedroom", label: "Bedroom", image: img("bedroom"), href: categoryPath("home-living") },
  { id: "bathroom", label: "Bathroom", image: img("bathroom"), href: categoryPath("home-living") },
  { id: "outdoor", label: "Outdoor", image: img("outdoor"), href: categoryPath("garden") },
  { id: "storage", label: "Storage", image: img("storage"), href: categoryPath("home-living") },
];

export const lifestyleCards: HomeLifestyleCard[] = [
  { id: "living", title: "Living Room", image: img("living-room"), href: categoryPath("home-living") },
  { id: "bedroom", title: "Bedroom", image: img("bedroom-life"), href: categoryPath("home-living") },
  { id: "kitchen", title: "Kitchen", image: img("kitchen-life"), href: categoryPath("home-living") },
  { id: "outdoor", title: "Outdoor", image: img("outdoor-life"), href: categoryPath("garden") },
];

export const topPicksTabs = [
  { id: "womens", label: "Women's Clothing" },
  { id: "mens", label: "Men's Clothing" },
  { id: "home", label: "Home" },
  { id: "toys", label: "Toys" },
];

export const featureCategoryCards: HomeFeatureCard[] = [
  { id: "women", label: "Women's", image: img("women-feature"), href: categoryPath("womens-clothing") },
  { id: "men", label: "Men's", image: img("men-feature"), href: categoryPath("mens-clothing") },
  { id: "kids", label: "Kids'", image: img("kids-feature"), href: categoryPath("kids-baby") },
  { id: "baby", label: "Baby", image: img("baby-feature"), href: categoryPath("kids-baby") },
];

export const promoBanners: HomePromoBanner[] = [
  {
    id: "move",
    title: "Get ready for your move",
    subtitle: "Storage, bedding and essentials",
    image: img("move-promo"),
    href: categoryPath("home-living"),
  },
  {
    id: "tech",
    title: "Tech deals",
    subtitle: "Phones, accessories and more",
    image: img("tech-promo"),
    href: categoryPath("tech-gaming"),
  },
];

export const brandChips = [
  "Anko",
  "Active & Co",
  "Smart Buy",
  "Maddison",
  "Bestway",
  "Optus",
];

export const familyContentCards: HomeContentCard[] = [
  {
    id: "family-1",
    title: "Family movie night",
    description: "Snacks, blankets and games for cosy evenings in.",
    image: img("family-movie"),
    href: categoryPath("toys"),
  },
  {
    id: "family-2",
    title: "Outdoor adventures",
    description: "Gear up for picnics and backyard fun.",
    image: img("family-outdoor"),
    href: categoryPath("sports-outdoor"),
  },
  {
    id: "family-3",
    title: "Back to school",
    description: "Lunch boxes, stationery and uniforms.",
    image: img("family-school"),
    href: searchPath("school"),
  },
];

export const serviceIcons: HomeServiceIcon[] = [
  { id: "cnc", label: "Click & Collect", description: "Ready in 4 hours" },
  { id: "delivery", label: "Free delivery", description: "On orders over $65" },
  { id: "returns", label: "Easy returns", description: "60-day change of mind" },
  { id: "prices", label: "Low prices", description: "Everyday value" },
];

export const communityPhotos = Array.from({ length: 6 }, (_, i) => ({
  id: `community-${i}`,
  image: img(`community-${i}`),
  alt: `Community photo ${i + 1}`,
}));
